import api from "../../../util/api";

const endpoint = "/interface/v1/locker/";

export default {
  async list({ commit }) {
    try {
      const res = await api.get(endpoint);
      const data = await res.json();
      commit("set", { data: data.results });
      return data.results;
    } catch (err) {
      return err;
    }
  },
  async listSort({ commit }, { sort }) {
    try {
      const res = await api.get(endpoint + sort);
      const data = await res.json();
      commit("set", { data: data.results });
      commit('getPage', {data: data})
      return data.results;
    } catch (err) {
      return err;
    }
  },
  async get({ commit }, { id }) {
    try {
      const res = await api.get(endpoint + id);
      const data = await res.json();
      commit("show", { data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async updatePatch({ commit }, { item }) {
    try {
      const res = await api.patch(endpoint + item.id + "/", item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async create({ commit }, { item }) {
    try {
      const res = await api.post(endpoint, item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async open({ commit }, { url, item }) {
    try {
      const res = await api.post(endpoint + url, item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async update({ commit }, { item }) {
    try {
      const res = await api.put(endpoint + item.id + "/", item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async updateConfig({ commit }, { item }) {
    try {
      const res = await api.patch(endpoint + item.id + "/", item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async create_shelf({ commit }, { id, data }) {
    try {
      const res = await api.post(endpoint + id + "/send_data_structure/", data);
      const result = await res.json();
      return result;
    } catch (err) {
      return err;
    }
  },
  async clone_locker({ commit }, { id, data }) {
    try {
      const res = await api.postMore(endpoint + id + "/clone/", data);
      return res;
    } catch (err) {
      return err;
    }
  },
  async outService({ commit }, { id, item }) {
    try {
      const res = await api.postMore(endpoint + id + '/service/', item);
      return res;
    } catch (err) {
      return err;
    }
  },
  async update_coils({ commit }, { item, data }) {
    try {
      const res = await api.put(endpoint + item + "/coil_update/", {
        coils: data
      });
      const result = await res.json();
      return result;
    } catch (err) {
      return err;
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      const res = await api.delete(endpoint + id);
      dispatch("list");
      return res;
    } catch (err) {
      return err;
    }
  }
};
